'use client';

import { __rest, __assign } from '../_virtual/_tslib.js';
import React__default from 'react';
import { Button } from './ButtonPrimary.css.js';

var ButtonType;
(function (ButtonType) {
    ButtonType[ButtonType["primary"] = 0] = "primary";
    ButtonType[ButtonType["secondary"] = 1] = "secondary";
})(ButtonType || (ButtonType = {}));
function ButtonPrimary(props) {
    var children = props.children, onClick = props.onClick, _a = props.type, type = _a === void 0 ? ButtonType.primary : _a, rest = __rest(props, ["children", "onClick", "type"]);
    return (React__default.createElement(Button, __assign({ type: type, onClick: onClick }, rest), children));
}

export { ButtonType, ButtonPrimary as default };
//# sourceMappingURL=index.js.map
